import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IStrapiDocuments, IUserUpdateChoice } from 'src/app/interfaces/strapi';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { AuthService } from '../../../services/auth.service';

type TypeOfChoice = 'account-exists' | 'no-longer-customer';

enum UserUpdateChoiceEnum {
  accountExists = 'account-exists',
  noLongerCustomer = 'no-longer-customer',
}

@Component({
    selector: 'app-user-update-choice',
    templateUrl: './user-update-choice-modal.component.html',
    styleUrls: ['./user-update-choice-modal.component.scss'],
    imports: [NgIf],
})
export class UserUpdateChoiceComponent implements OnInit {
  @Input() choice: TypeOfChoice = 'account-exists' as TypeOfChoice;

  public modalData: IUserUpdateChoice = {} as IUserUpdateChoice;

  public isLoading: boolean = false;

  public contentRetrievalError: boolean = false;

  @Output() private readonly updateDetails: EventEmitter<boolean> =
    new EventEmitter();

  constructor(
    private readonly strapi: StrapiService,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    switch (this.choice) {
      case UserUpdateChoiceEnum.accountExists:
        this.strapi.getUserUpdateChoice('registration').subscribe({
          next: (data: IStrapiDocuments<IUserUpdateChoice>) => {
            this.modalData = data.data[0].attributes;
          },
          error: () => {
            this.contentRetrievalError = true;
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          },
        });
        break;
      case UserUpdateChoiceEnum.noLongerCustomer:
        this.strapi.getUserUpdateChoice('update-details').subscribe({
          next: (data: IStrapiDocuments<IUserUpdateChoice>) => {
            this.modalData = data.data[0].attributes;
            this.modalData.content = this.modalData.content.replaceAll(
              '<name>',
              this.authService.currentUser?.university?.name ?? ''
            );
            this.modalData.title = this.modalData.title.replaceAll(
              '<name>',
              this.authService.currentUser?.university?.name ?? ''
            );
            this.modalData.dont_update_account_button_text =
              this.modalData.dont_update_account_button_text.replaceAll(
                '<name>',
                this.authService.currentUser?.university?.name ?? ''
              );
            this.modalData.update_account_button_text =
              this.modalData.update_account_button_text.replaceAll(
                '<name>',
                this.authService.currentUser?.university?.name ?? ''
              );
          },
          error: () => {
            this.contentRetrievalError = true;
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          },
        });
        break;
      default:
        break;
    }
  }

  /**
   * Emit user wants to update their details
   */
  update(): void {
    this.updateDetails.emit(true);
  }

  /**
   * Emit user doesn't want to update their details
   */
  dontUpdate(): void {
    this.updateDetails.emit(false);
  }
}
